import type { MotifComponent, MotifComponentProps } from '../../motif';
import { mediaVars } from './Media.palette';

export const snapMediaVars: MotifComponentProps<MotifComponent.MEDIA> = {
  ...mediaVars,
  '--media-border-radius': '0px',
} as const;
